import { Button, Result } from 'antd';
import { useHistory } from 'react-router-dom';
import React from 'react';
import { ROUTES } from './common/constants';

const Error404 = () => {
  const history = useHistory();
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" onClick={() => history?.push(ROUTES?.MAIN)}>
          Back Home
        </Button>
      }
    />
  );
};

export default Error404;
